import Product from "@system/config/product";
import ProductListingAPICallResponseMaker from "src/service/reponseMaker/productResponseMaker";
import { __remove, __set } from "../store/axios_indicator";
import System from "src/helper/system";
import Api from "src/service/APIHandler";
const API = new Api({});

class ProductDetailAPICall {

    getAlternativeProductByVariantNumber = async (ItemNum, orderBy = '', top = 10, skip = 0) => {
        const res = {};
        const param = {}
        param.data = {
            "speedBoat": System.avUserInfoData.speedBoatAbbr,
            "ItemNum": ItemNum,
            "productResponseTypes": "CountWithData",
            "orderby": orderBy,
            "top": top,
            "skip": skip
        }
        try {
            await API.post(Product.PRODUCT_ALTERNATIVE_DATA_LIST, param).then((resHer) => {
                if (resHer.data?.Data) {
                    res.data = resHer?.data?.Data
                }
            });
        } catch (e) {
        }
        const res_made = new ProductListingAPICallResponseMaker(res).process().run().get();
        return res_made;
    };

    getAlternativeProductCountByVariantNumber = async (ItemNum) => {
        let res = {};
        const param = {}
        param.data = {
            "speedBoat": System.avUserInfoData.speedBoatAbbr,
            "ItemNum": ItemNum,
            "productResponseTypes": "CountOnly",
            "orderby": "",
            "top": 0,
            "skip": 0
        }
        try {
            await API.post(Product.PRODUCT_ALTERNATIVE_DATA_LIST, param).then((resHer) => {
                if (resHer.data?.Data) {
                    res = resHer?.data?.Data?.Count
                }
            });
        } catch (e) {
        }
        return res;
    };

    sendReportErrorEmail = async (data) => {
        let res = {};
        const param = {}
        param.data = data
        try {
            await API.post(Product.PRODUCT_REPORT_ERROR, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            res = e.response.data;
        }
        return res;
    };

    getProductCategory = async () => {
        const param = {
            params: {
                sboat: System.avUserInfoData.speedBoatAbbr
            }
        };

        let res = await API.get(Product.PRODUCT_CATEGORY_LIST, param);
        res = res.data?.data || {};

        const processCategories = (categories = {}) => {
            let f = [];
            let Count = 0;

            if (categories && Object.keys(categories).length > 0) {
                categories = categories.map(v => ({
                    ...v,
                    value: v.name,
                    count: v.count
                }));

                categories.map((v, i) => {
                    let here = {
                        value: v.value,
                        Value: v.Value,
                        Name: v.value,
                        count: v.count,
                        Count: v.count,
                        level: v.level,
                        url: v.url
                    };
                    v.Categories = v.categories;
                    if (v.Categories && v.Categories.length) {
                        let inner_res = processCategories(v.Categories);
                        here.Categories = inner_res.Categories;
                        here.Count = here.Count + inner_res.count;
                    }
                    Count = Count + here.Count;
                    f.push(here);
                });
            }

            return {
                Categories: f,
                count: Count,
                slug: 'Categories',
                main_label: 'Categories',
                Count: Count
            };
        };

        return processCategories(res);
    };

    getProductDocumentList = async (payload) => {
        let res = {};
        const param = {}
        param.data = {
            "speedBoat": System.avUserInfoData.speedBoatAbbr,
            "filter": payload.filter,
            "isIncludeCount": true,
            "orderby": payload.orderby,
            "top": payload.top,
            "skip": 0,
            "isSkipFacets": true,
            "searchColumns": [],
            "searchType": "ProductDocuments",
            "search": "*"
        }
        await API.post(Product.PRODUCT_DOCUMENT_LIST, param).then((resHer) => {
            if (resHer.data?.Data) {
                res = resHer?.data?.Data
            }
        });
        return res;
    }

    getProductDocumentImageList = async (data) => {
        let res = {};
        const param = {}
        param.data = data
        await API.post(Product.PRODUCT_VARIANT_ASSET_LIST, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    }

    getAllDesignsData = async (designArray) => {
        let res = {};
        const param = {}
        param.data = { designIds: designArray, speedboat: System.avUserInfoData.speedBoatAbbr }
        await API.post(Product.GET_DESIGN_DATA, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    }

    checkDesignsExist = async (itemNumbers) => {
        let res = {};
        const param = {}
        param.data = itemNumbers
        param.params = { speedboat: System.avUserInfoData.speedBoatAbbr }
        await API.post(Product.CHECK_DESIGNS_EXIST, param).then((resHer) => {
            if (resHer.data) {
                res = resHer?.data
            }
        });
        return res;
    }

    getProductManufactureExternalSearch = async (requestUrl) => {
        let res = {};
        const param = {}
        param.data = {
            "sBoat": System.avUserInfoData.speedBoatAbbr,
            "url": requestUrl
        }
        await API.post(Product.PRODUCT_MANUFACTURE_EXTERNAL_SEARCH, param).then((resHer) => {
            if (resHer.data?.data) {
                res = resHer?.data?.data
            }
        });
        return res;
    }

    getProductManufactureExternalHeading = async (requestUrl) => {
        let res = {};
        const param = {}
        param.data = {
            "sBoat": System.avUserInfoData.speedBoatAbbr,
            "url": requestUrl
        }
        await API.post(Product.PRODUCT_MANUFACTURE_EXTERNAL_HEADING, param).then((resHer) => {
            if (resHer.data?.data) {
                res = resHer?.data?.data
            }
        });
        return res;
    }
}

export default ProductDetailAPICall;